var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customers-page"},[_c('div',{staticClass:"customers-section"},[_c('ulu-customers-charts')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }